/* eslint-disable react/jsx-no-undef */
import React , {useState }from "react";

// import { useNavigate } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import backgroundSuccess from '../../assets/images/register/bg-success.png';
import correct from '../../assets/images/checkmark.png'
import TransparentButton from "../../components/button/TransparentButton";
import coupon2 from '../../assets/images/coupon2.png';
import helper from "../../functions/helper";
import dayjs from "dayjs";

export default function MemberCouponSuccess() {
  const store = useSelector((state) => state.member)
  const couponDetail = React.useState(store['couponDetail']);
  const now = dayjs(Date())
  const navigate = useNavigate();


  return (
    <>
      <TopLogo />
     
        <div
          style={{
            background: `url(${backgroundSuccess}) no-repeat center center fixed`,
            minHeight: "calc(100vh - 60px)",
            padding: "25px",
            backgroundSize: "cover"
          }}
        >
          <img
            className="mx-auto"
            src={correct}
            alt="logo"
            style={{ width: "52px" }}
          />
          <div className="text-white text-center text-[34px] mt-[10px]">
            ใช้คูปองเรียบร้อย
          </div>

          <div className="text-white text-center text-[24px] mt-[10px]">
            {couponDetail[0].coupon.name}
          </div>

          <div className="text-white text-center text-[20px]">
            ส่วนลด {couponDetail[0].coupon.discountText}
          </div>

          {couponDetail[0].coupon.picture ? (
            <img
              className="mx-auto mt-[10px]"
              src={couponDetail[0].coupon.picture}
              alt="logo"
              style={{ width: "208px" }}
            />
          ) : (
            <img
              className="mx-auto mt-[10px]"
              src={coupon2}
              alt="logo"
              style={{ width: "208px" }}
            />
          )
          }

          <p className="text-white text-[24px]">รายละเอียด</p>
          <div className="white-line"></div>
          <div className="mt-[5px] flex justify-between items-start">
            <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
              รหัสคูปอง:
            </p>
            <p className="text-white text-[20px]">{couponDetail[0].qrCode}</p>
          </div>
          <div className="flex justify-between items-start">
            <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
              วันที่/เวลาแลกคูปอง:
            </p>
            <p className="text-white text-[20px]">{dayjs(now, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')}น.</p>
          </div>

          <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
            สถานที่ใช้งานคูปอง:
          </p>
          <p className="text-white text-[20px]">{couponDetail[0].shop.name}</p>
          {/* <div className="flex justify-between items-start">
          <p className="text-white text-[16px] whitespace-pre-line leading-[24px]">
            จำนวนสินค้า :
          </p>
          <p className="text-white text-[20px]">1SKU</p>
        </div> */}

          <div className="text-center mt-[50px]">
            <div className="my-4">
              <TransparentButton variant="contained"
                className="w-full"
                onClick={() => {
                  navigate('/member-coupon')
                }}>
                เสร็จสิ้น
              </TransparentButton>

            </div>

          </div>
        </div>
      
    </>
  );
}
